import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { CatAgreementModel } from 'src/app/model/cat-agreement.model';
import { CatAgreementService } from 'src/app/services/cat-agreement.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalCatAgreementComponent } from 'src/app/shared/modal-cat-agreement/modal-cat-agreement.component';
import { extractUploadErrorMessages } from 'src/app/utils/upload-error.util';
import { downloadBlobFile } from 'src/app/utils/download-file.util';

@Component({
  selector: 'app-cat-agreement',
  templateUrl: './cat-agreement.component.html',
  styleUrls: ['./cat-agreement.component.css']
})
export class CatAgreementComponent implements OnInit {
  // estado pagina
  public viewStatus = 0;  // -1:nada, 0:spinner, 1:tabla
  public agreements: CatAgreementModel[] = [];

  // carga de excel
  @ViewChild('fileInput', { static: false }) fileInputRef: ElementRef;
  public uploadFile: File = null;
  public replaceAll = false;

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 140, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator: CreatorService,
    private modalService: NgbModal,
    private agreementService: CatAgreementService,
    private toastr: ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add = () => {
    let agreement = this.creator.newCatAgreement();
    let modalRef = this.modalService.open(ModalCatAgreementComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal' });
    modalRef.componentInstance.agreement = { ...agreement };
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  edit = (agreement: CatAgreementModel) => {
    let modalRef = this.modalService.open(ModalCatAgreementComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal' });
    modalRef.componentInstance.agreement = { ...agreement };
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }

  // ACTIVAR / DESACTIVAR (PUT explicito; nunca se elimina el registro de la tabla)
  deactivate = (agreement: CatAgreementModel) => {
    Swal.fire({
      title: '¿Desactivar convenio?',
      html: 'Se desactivará <strong>' + agreement.description + '</strong>. El registro no se elimina, solo deja de estar activo.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, desactivar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.setActive(agreement, false, 'El convenio se desactivó con éxito.', 'Ocurrió un error al intentar desactivar el convenio.');
      }
    });
  }

  reactivate = (agreement: CatAgreementModel) => {
    Swal.fire({
      title: '¿Reactivar convenio?',
      html: 'Se reactivará <strong>' + agreement.description + '</strong>.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, reactivar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.setActive(agreement, true, 'El convenio se reactivó con éxito.', 'Ocurrió un error al intentar reactivar el convenio.');
      }
    });
  }

  private setActive = (agreement: CatAgreementModel, active: boolean, successMessage: string, errorMessage: string) => {
    const userId = Number(localStorage.getItem('com_token'));
    this.viewStatus = 0;
    this.agreementService.setActive(agreement.agreementId, active, userId)
      .pipe(
        tap((resp: any) => {
          if (resp && resp.codeHttpStatus === 200) {
            this.toastr.success(successMessage);
            // actualizar estado local para no depender de una segunda consulta
            agreement.activeId = active;
            this.getCatalogs();
          } else {
            this.viewStatus = 1;
            this.toastr.error(resp && resp.messageError ? resp.messageError : errorMessage);
          }
        }),
        catchError(error => {
          this.viewStatus = 1;
          const messageError = error && error.error && error.error.messageError;
          return of(this.toastr.error(messageError || errorMessage));
        })
      )
      .subscribe();
  }

  // EXCEL
  onFileSelected = (event: any) => {
    this.uploadFile = event.target.files.length > 0 ? event.target.files[0] : null;
  }
  uploadExcel = () => {
    if (!this.uploadFile) {
      this.toastr.warning('Selecciona un archivo Excel primero.');
      return;
    }
    let userName = localStorage.getItem('com_userName');
    this.viewStatus = 0;
    this.agreementService.upload(userName, this.uploadFile, this.replaceAll)
      .pipe(
        tap((resp: any) => {
          if (resp && resp.codeHttpStatus === 200) {
            this.resetFileInput();
            this.getCatalogs(() => {
              this.toastr.success(`El catálogo se cargó correctamente. Registros disponibles: ${this.agreements.length}.`);
            });
          } else {
            this.viewStatus = 1;
            const messages = extractUploadErrorMessages(resp);
            this.toastr.error(messages.join('<br>'), '¡Atención!', { enableHtml: true });
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.viewStatus = 1;
          const messages = extractUploadErrorMessages(error);
          this.toastr.error(messages.join('<br>'), '¡Atención!', { enableHtml: true });
          return of(null);
        })
      )
      .subscribe();
  }
  resetFileInput = () => {
    this.uploadFile = null;
    if (this.fileInputRef) this.fileInputRef.nativeElement.value = '';
  }
  downloadLayout = () => {
    this.agreementService.downloadLayout().subscribe(
      (data: Blob) => downloadBlobFile(data, 'layout_convenios.xlsx'),
      () => this.toastr.error('No se pudo descargar el layout.')
    );
  }

  // INFO
  getCatalogs = (onDone?: () => void) => {
    this.agreementService.getAll()
      .pipe(
        tap((resp: any) => {
          this.agreements = resp.data || [];
          this.viewStatus = 1;
          if (onDone) onDone();
        }),
        catchError(error => {
          this.viewStatus = -1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de convenios.'));
        })
      )
      .subscribe();
  }
}
